import type { ReactElement } from 'react';
import { formatCount } from '@/shared/lib';

export interface TotalQuantityProps {
  /** 배송지 수량 합계 — 카드 수량이 하나라도 정수가 아니면 null(— 로 보인다). */
  readonly total: number | null;
  readonly minOrderQty: number;
  /** 합계 규칙 오류(최소 주문 수량·금액 상한) — 총 수량 아래에 보인다. */
  readonly error?: string | undefined;
}

/**
 * 총 수량(읽기 전용, spec §6-1) — 견적 수량은 배송지 수량 합계이고 최소 주문 수량은 합계에 적용한다(spec D5).
 * 카드 수량을 바꿀 때마다 바뀌므로 status 로 조용히 알린다.
 */
export const TotalQuantity = ({ total, minOrderQty, error }: TotalQuantityProps): ReactElement => (
  <div className="flex flex-col gap-1.5">
    <div
      role="status"
      aria-label="총 수량"
      className="flex items-baseline justify-between gap-4 bg-muted/40 px-5 py-4"
    >
      <span className="text-sm font-medium">총 수량</span>
      <span className="text-xl font-bold tracking-[-0.01em] tabular-nums">
        {total === null ? '—' : `${formatCount(total)}개`}
      </span>
    </div>
    <p className="text-xs text-muted-foreground">최소 주문 수량 {formatCount(minOrderQty)}개</p>
    {error ? (
      <p role="alert" className="text-xs text-destructive">
        {error}
      </p>
    ) : null}
  </div>
);
